import {Inject, Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {catchError, EMPTY, Observable, throwError} from 'rxjs';
import {Router} from "@angular/router";
import {LOGIN_TOKEN} from "../tokens/tokens";
import {ToastrService} from "ngx-toastr";


@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(private router: Router,
              private toastService: ToastrService,
              @Inject(LOGIN_TOKEN) private loginToken: string) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((httpErrorResponse: HttpErrorResponse) => {
        let handled = false;
        if (httpErrorResponse.error instanceof ErrorEvent) {
        } else {
          switch (httpErrorResponse.status) {
            case 401:
              this.router.navigateByUrl("/unauthorized");
              sessionStorage.removeItem(this.loginToken);
              handled = true;
              break;
            case 403:
              this.router.navigateByUrl("/forbidden")
              handled = true;
              break;
            case 404:
              this.router.navigateByUrl("/server-not-found")
              handled = true;
              break;
            case 500:
              //this.router.navigateByUrl("/error")
              //handled = true; (I added toaster messages in subscribers error method, so we need to raise error.)
              break;
            case 0:
              this.toastService.error('Connection failed. Please check your internet network.');
              handled = true;
              break;
          }
        }
        if (handled) {
          return EMPTY;
        } else {
          //Rethrow it back to component
          return throwError(() => httpErrorResponse.error);
        }
      })
    );
  }
}
